import React from 'react';
import { classes } from 'typestyle';
import Box from '../box/box.component';
import {
    tableBackgroundClassName,
    tableScrollClassName,
    tableClassName,
    tableThemeGreenClassName,
    tableContainerClassName,
    tableFixedClassName
} from './table.style';
import { ThemeName } from '../../../types';

interface TableProps {
    children?: React.ReactNode,
    fixedColumns?: boolean,
    theme?: ThemeName
}

const Table: React.FC<TableProps> = ({
    children,
    fixedColumns = false,
    theme = 'blue'
}) => {
    return (
        <Box className={ tableContainerClassName }>
            <div className={ tableBackgroundClassName }/>
            <div className={ tableScrollClassName }>
                <table
                    border={ 0 }
                    cellSpacing='0'
                    className={ classes(
                        tableClassName,
                        (theme === 'green') && tableThemeGreenClassName,
                        fixedColumns && tableFixedClassName
                    ) }
                    children={ children }/>
            </div>
        </Box>
    );
};

export default Table;
